var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6884 14.0002H6.04255M5.94026 14.3403L3.11889 22.4775C2.89724 23.1167 2.78642 23.4364 2.86595 23.6332C2.93502 23.8041 3.08336 23.9337 3.2664 23.9831C3.47718 24.0399 3.79553 23.9015 4.43224 23.6249L24.6253 14.8514C25.2467 14.5814 25.5575 14.4463 25.6535 14.2588C25.737 14.0958 25.737 13.9047 25.6535 13.7417C25.5575 13.5542 25.2467 13.4191 24.6253 13.1491L4.4252 4.37259C3.79041 4.09678 3.47302 3.95888 3.26245 4.01545C3.07958 4.06458 2.93126 4.19383 2.86195 4.36445C2.78215 4.56091 2.89179 4.87985 3.11107 5.51773L5.94104 13.75C5.9787 13.8596 5.99753 13.9144 6.00497 13.9704C6.01156 14.0201 6.0115 14.0704 6.00477 14.1201C5.99719 14.1761 5.97821 14.2309 5.94026 14.3403Z",
    stroke: "#2B3D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d4e84bb29159af27910c9fc4ee23a14b.svg";
export { ForwardRef as ReactComponent };